import { preventScroll, restoreScroll } from "../utils/prevent-scroll";

document.addEventListener("DOMContentLoaded", () => {
  let menuClosed = false;
  const menu = document.querySelector(".Menu");
  const searchToggleCheckbox = document.querySelector("#search-checkbox");
  [...document.querySelectorAll("[data-menu-toggle]")].forEach(
    (toggleButton) => {
      toggleButton.addEventListener("click", () => {
        menu.classList.add("transition-transform");
        menuClosed = menu.classList.toggle("translate-x-full");

        searchToggleCheckbox.checked = !menuClosed;

        toggleButton.classList.toggle("open");

        const hamburgerStrokes = document.querySelectorAll(".Hamburger-stroke");
        hamburgerStrokes.forEach((stroke) => {
          stroke.classList.toggle("active");
        });

        if (menuClosed) {
          restoreScroll(0);
        } else {
          preventScroll(0);
        }
      });
    }
  );

  // matches the `md` breakpoint used for desktop nav in header-menu.css
  const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;

  // Handle submenus and submenu button
  const subMenus = menu.querySelectorAll(".menu-item-has-children");
  subMenus.forEach((subMenu) => {
    const submenuWrapper = subMenu.querySelector(".Menu-subMenu-wrapper");
    if (submenuWrapper) {
      submenuWrapper.setAttribute("aria-hidden", true);
    }

    // the item's own link, not a link inside the nested submenu
    const directLink = subMenu.querySelector(":scope > a");
    const button = subMenu.querySelector(".Menu-subMenuButton");

    subMenu.addEventListener("click", (e) => {
      const clickedButton = e.target.closest(".Menu-subMenuButton");
      const clickedDirectLink =
        directLink && (e.target === directLink || directLink.contains(e.target));

      // on mobile, clicking anywhere on the row expands the submenu
      // instead of following the link; on desktop the link still navigates
      if (clickedButton || (clickedDirectLink && !isDesktop())) {
        e.preventDefault();
        e.stopPropagation();
        // handle toggle
        button.classList.toggle("is-active");
        submenuWrapper.setAttribute(
          "aria-hidden",
          !button.classList.contains("is-active")
        );
      }
    });
  });

  // Close all submenus when clicking outside
  function closeAllSubNavs() {
    [...document.querySelectorAll(".menu-item-has-children")].forEach(
      (submenu) => {
        const button = submenu.querySelector(".Menu-subMenuButton");
        const wrapper = submenu.querySelector(".Menu-subMenu-wrapper");

        if (button) {
          button.classList.remove("is-active");
        }

        if (wrapper) {
          wrapper.setAttribute("aria-hidden", true);
        }
      }
    );
  }
  document.addEventListener("click", closeAllSubNavs);
});
